import React from "react";
import ParseHTML from "../../common/ParseHTML";
import CustomSection from "../custom-general/custom-section";

const DEFAULT_INSPECTION_OVERVIEW = `
    <h2><strong>INSPECTION OVERVIEW:</strong></h2>

    <p>This investigation is employing the use of thermographics and infra-red in order to assess the levels of sediment deposits within the process vessels indicated. The object is to provide initial sediment level assessment and to provide baseline thermograms for comparative future inspections so that levels can be monitored and trended accordingly.</p>

    <p>The baseline thermograms can then be used as a reference point against subsequent images from periodic inspections. This will allow the sediment levels to be monitored along with specific temperature readings of the vessels.</p>

    <p>The table shown at the end of each InfraRed analysis page shows estimated percentage levels of sediment in relation to the diameter of the separator and a direct comparison can be made between inspections to see the increases or decreases quickly and accurately.</p>

    <h2><strong>THEORY:</strong></h2>

    <p>Deposited sediment will be visible to infra-red due to the insulating effect it has on the surface temperature of the process vessels. This means that areas of material deposit will appear with a lower temperature than areas which do not suffer from deposits as the heat from the separators/degasser will have to travel through more material, in this case sand.   </p>

    <p>These lower temperature signatures can be attributed to internal deposits within so long as the external surface area is clean and not affecting the thermograms. The separators/vessels have a continuous outer shell material which means emissivity will remain constant. </p>

    <p>The measurement level is taken from the base of the separator to the centre of the yellow line which is suspected of being a foam level whilst the underlying sediment level is suspected of lying just beneath this. </p>

    <h2><strong>INSPECTION METHODS:</strong></h2>

    <ul>
        <li>Visual inspection- for finding any irregularities in the vessel.</li>
        <li>360˚ accessibility should be available to make the image capture relatively straight forward.  </li>
        <li>There must be no insulation present on any of the vessels inspected.  </li>
        <li>Images are then captured of all vessels comprehensively recording all lower sections of the vessels and any other areas which may benefit from temperature analysis.</li>
    </ul>

    <h2><strong>STATEMENT:</strong></h2>

    <p>The suggestions and opinions in this report are interpretations of the thermograms by the thermographer at the time of inspection. These are not definitive comments and do not claim to be absolutes.  </p>

    <p>It is recommended that these interpretations be used in conjunction with other NDT inspection methods to determine the overall condition of the asset.  </p>

    <p>Conclusions are based on the thermal variations.</p>
`;

const InspectionOverview: React.FC = () => {
    return ( 
        <CustomSection sectionTitle="Inspection Overview">
            <div className="p-3">
                <ParseHTML text={DEFAULT_INSPECTION_OVERVIEW} />
            </div>
        </CustomSection>
    );
};
 
export default InspectionOverview;